// extracted by mini-css-extract-plugin
export var bottomRightDock = "_11-0";